<template lang="html">
  <div class="button-header">
       <div class="v-header">
         <span class="back" @click="goBack()">
             <img src="../assets/common/common_btn_left_big_white@2x.png" alt="">
         </span>
         <span class="love">
             <img src="../assets/common/common_btn_like_nor@2x.png" alt="">
         </span>
         <span class="share">
             <img src="../assets/common/common_btn_share@2x.png" alt="">
         </span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'buttonHeader',
  data(){
    return {
        
    }
  },
  created(){

  },
  methods: {
      goBack() {
          this.$router.go(-1)
      }
  }
}
</script>

<style lang="css" scoped>
.button-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    /* background: transparent; */
    z-index: 100;
}
.v-header {
    /* padding: .27rem .27rem .27rem .16rem; */
    padding: .51rem 0;
    position: relative;
    font-size: 0.36rem;
    text-align: center;
    background: rgba(137, 137, 137, 0.65);
}
.v-header>span {
    display: inline-block;
    width: .4rem;
    height: .4rem;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}
span>img {
    width: 100%;
    height: 100%;
}
.back {
    left:.16rem;
}
.love {
    right: 1.04rem;
}
.share {
    right: .16rem;
}
</style>




// WEBPACK FOOTER //
// src/components/buttonHeader.vue